// src/stockx/base/ClockIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var ClockIcon = ({ colorized, ...props }) => /* @__PURE__ */ jsxs(Icon, { viewBox: "0 0 50 50", ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M25 43C15.1 43 7 34.9 7 25C7 15.1 15.1 7 25 7C34.9 7 43 15.1 43 25C43 34.9 34.9 43 25 43ZM25 9.3C16.3 9.3 9.3 16.3 9.3 25C9.3 33.7 16.3 40.7 25 40.7C33.7 40.7 40.7 33.7 40.7 25C40.7 16.3 33.7 9.3 25 9.3Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M30.9999 29.9L23.8999 25.6V14.8H26.0999V24.4L32.0999 28L30.9999 29.9Z",
      fill: colorized ? "black" : "currentColor"
    }
  )
] });
var ClockIcon_default = ClockIcon;

export {
  ClockIcon_default
};
